export const TOGGLE_EXPANDED = 'toggle-expanded';
export const SET_EXPANDED = 'set-expanded';
export const SET_CURRENT_USER = 'set-current-user';
